import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import api from "../axios/api";

export const uploadSignature = async (signature: { canvas: string } | null) => {
  const uuid = uuidv4();

  if (signature) {
    const file = await dataUrlToFile(signature.canvas, `${uuid}.png`);

    const payloadToSign = {
      fileType: file.type,
      name: file.name,
    };

    try {
      const signUrlRes: {
        data: { id: string; url: string; contentType: string; fileName: string }} = await api.post("/files/signurl", { file: payloadToSign });

      await axios.put(signUrlRes.data.url, file, {
        headers: { "Content-Type": signUrlRes.data.contentType },
      });

      const body = {
        name: signUrlRes.data.fileName,
        key: `files/${signUrlRes.data.fileName}`,
        mimetype: signUrlRes.data.contentType,
      };

      const signatureFile = await api.post("/files", body);

      return {id:signatureFile.data._id, url: signatureFile.data.url};
    } catch (e) {
      console.log(e);
    }
  } else return
};

export const dataUrlToFile = async (dataUrl: string, fileName: string) => {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], fileName, { type: "image/png" });
};
